import styled from 'styled-components'

export const TableCenterData = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 27.5rem;
`
